import React from 'react';

const PostPin: React.FC = () => {
    return <div className='my-1'>
                <div className='rounded-full font-cgbold text-sm py-2 px-6 bg-green2 mr-2'>Pinned</div>
           </div>
}

export default PostPin